module.exports = __webpack_public_path__ + "img/widget_0007.0b6c4480.png";